module.exports = __webpack_public_path__ + "static/img/2018.b2992a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/huaiBrand/2018.png
// module id = KSDQ
// module chunks = 0